module.exports = __webpack_public_path__ + "static/media/cotyBanner-desktop-1220x150@1x.3c91e7a4.jpg";